import { createRoute, PATHS, PUBLIC_PATH } from '@src/core/router/paths';
import {
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@src/design-system/dropdown-menu';
import { deleteCredentials } from '@src/shared/utils/delete-credentials';
import { useQueryClient } from '@tanstack/react-query';
import { Buliding, LogoutCurve } from 'iconsax-react';
import { User } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

export function ProfileMenuActions() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleLogout = () => {
    queryClient.clear();
    deleteCredentials();
    navigate(PUBLIC_PATH.LOGIN);
  };

  return (
    <>
      <DropdownMenuItem
        className='border justify-center items-center text-sm text-center transition-colors my-2 border-primary-200 text-primary-900 rounded-lg'
        asChild
      >
        <Link to={createRoute(PATHS.SETTINGS_BRANCHES)}>Manage Branches</Link>
      </DropdownMenuItem>

      <DropdownMenuSeparator />

      <DropdownMenuItem asChild>
        <Link
          className='flex gap-1'
          to={createRoute(PATHS.SETTINGS_PROFILE_SETTINGS)}
        >
          <User size='20' />
          My Profile
        </Link>
      </DropdownMenuItem>

      <DropdownMenuItem className='flex gap-2'>
        <Buliding size='20' />
        <Link to={createRoute(PATHS.SETTINGS)}>Organization Profile</Link>
      </DropdownMenuItem>

      <DropdownMenuItem
        onClick={handleLogout}
        className='text-red-500 flex gap-2'
      >
        <LogoutCurve size='20' /> Logout
      </DropdownMenuItem>
    </>
  );
}
